import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { authApi } from "./redux/api/auth";
import layoutListenerMiddleware from "./redux/api/layout/layoutListener";
import featureApis from "./featureApis";

/**
 * Redux store EyeHub.
 *
 * Composition легко расширяется: чтобы добавить feature-api-слайс, страница
 * регистрирует его в src/store/featureApis.js — reducer и middleware
 * подключаются автоматически (см. featureApis.js).
 */
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(layoutListenerMiddleware)
      .concat(authApi.middleware)
      .concat(featureApis.map((api) => api.middleware)),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
